import type { EnvironmentProviders } from '@angular/core';
import { makeEnvironmentProviders } from '@angular/core';
import { CONFIG } from '@config';

import { LOYALTY_CONFIG } from './config.token';

export const provideLoyalty = (): EnvironmentProviders =>
  makeEnvironmentProviders([{ provide: LOYALTY_CONFIG, useValue: { baseUrl: CONFIG.loyaltyApiUrl } }]);
